import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./MarqueeLabel.scss");

export interface MarqueeLabelProps {
    readonly children: React.ReactNode;
}

export default function MarqueeLabel({ children }: MarqueeLabelProps) {
    return (
        <div className={classnames(style.marqueeLabel)}>
            <p>{children}</p>
        </div>
    );
}
